{
  "SUM": "SUM",
  "AVERAGE": "AVERAGE",
  "MIN": "MIN",
  "MAX": "MAX",
  "COUNT": "COUNT",
  "IF": "IF",
  "AND": "AND",
  "OR": "OR",
  "NOT": "NOT",
  "TRUE": "TRUE",
  "FALSE": "FALSE",
  "CONCAT": "CONCAT",
  "CONCATENATE": "CONCATENATE",
  "LEFT": "LEFT",
  "RIGHT": "RIGHT",
  "MID": "MID",
  "LEN": "LEN",
  "LOWER": "LOWER",
  "UPPER": "UPPER",
  "TRIM": "TRIM",
  "ABS": "ABS",
  "ROUND": "ROUND",
  "SQRT": "SQRT",
  "POWER": "POWER",
  "MOD": "MOD",
  "IFERROR": "IFERROR",
  "ISERROR": "ISERROR",
  "ISBLANK": "ISBLANK",
  "VALUE": "VALUE",
  "SUBSTITUTE": "SUBSTITUTE",
  "FIND": "FIND",
  "VLOOKUP": "VLOOKUP",
  "HLOOKUP": "HLOOKUP",
  "INDEX": "INDEX",
  "MATCH": "MATCH",
  "TEXT": "TEXT",
  "COUNTIFS": "COUNTIFS",
  "SUMIF": "SUMIF",
  "SUMIFS": "SUMIFS",
  "AVERAGEIF": "AVERAGEIF",
  "AVERAGEIFS": "AVERAGEIFS"
  ,"ISNUMBER": "ISNUMBER"
  ,"ISTEXT": "ISTEXT"
  ,"MEDIAN": "MEDIAN"
  ,"STDEV": "STDEV"
  ,"DATE": "DATE"
  ,"YEAR": "YEAR"
  ,"MONTH": "MONTH"
  ,"DAY": "DAY"
  ,"TODAY": "TODAY"
  ,"LN": "LN"
  ,"ROUNDUP": "ROUNDUP"
  ,"ROUNDDOWN": "ROUNDDOWN"
  ,"INT": "INT"
  ,"CEILING": "CEILING"
  ,"CEILING.MATH": "CEILING.MATH"
  ,"FLOOR": "FLOOR"
  ,"FLOOR.MATH": "FLOOR.MATH"
  ,"PRODUCT": "PRODUCT"
  ,"SUMPRODUCT": "SUMPRODUCT"
  ,"RAND": "RAND"
  ,"RANDBETWEEN": "RANDBETWEEN"
  ,"SIGN": "SIGN"
  ,"PI": "PI"
  ,"LOG": "LOG"
  ,"LOG10": "LOG10"
  ,"EXP": "EXP"
  ,"TRUNC": "TRUNC"
  ,"EVEN": "EVEN"
  ,"ODD": "ODD"
  ,"GCD": "GCD"
  ,"LCM": "LCM"
  ,"MROUND": "MROUND"
  ,"QUOTIENT": "QUOTIENT"
  ,"RADIANS": "RADIANS"
  ,"DEGREES": "DEGREES"
  ,"SUBTOTAL": "SUBTOTAL"
  ,"FACT": "FACT"
  ,"COMBIN": "COMBIN"
  ,"SUMSQ": "SUMSQ"
  ,"IFNA": "IFNA"
  ,"IFS": "IFS"
  ,"SWITCH": "SWITCH"
  ,"XOR": "XOR"
  ,"XLOOKUP": "XLOOKUP"
  ,"XMATCH": "XMATCH"
  ,"LOOKUP": "LOOKUP"
  ,"ROW": "ROW"
  ,"ROWS": "ROWS"
  ,"COLUMN": "COLUMN"
  ,"COLUMNS": "COLUMNS"
  ,"CHOOSE": "CHOOSE"
  ,"ADDRESS": "ADDRESS"
  ,"TRANSPOSE": "TRANSPOSE"
  ,"COUNTA": "COUNTA"
  ,"COUNTBLANK": "COUNTBLANK"
  ,"COUNTIF": "COUNTIF"
  ,"LARGE": "LARGE"
  ,"SMALL": "SMALL"
  ,"RANK": "RANK"
  ,"RANK.EQ": "RANK.EQ"
  ,"RANK.AVG": "RANK.AVG"
  ,"STDEV.S": "STDEV.S"
  ,"STDEV.P": "STDEV.P"
  ,"STDEVP": "STDEVP"
  ,"VAR": "VAR"
  ,"VAR.S": "VAR.S"
  ,"VAR.P": "VAR.P"
  ,"VARP": "VARP"
  ,"MAXIFS": "MAXIFS"
  ,"MINIFS": "MINIFS"
  ,"AVERAGEA": "AVERAGEA"
  ,"MAXA": "MAXA"
  ,"MINA": "MINA"
  ,"PERCENTILE": "PERCENTILE"
  ,"PERCENTILE.INC": "PERCENTILE.INC"
  ,"PERCENTILE.EXC": "PERCENTILE.EXC"
  ,"QUARTILE": "QUARTILE"
  ,"QUARTILE.INC": "QUARTILE.INC"
  ,"FREQUENCY": "FREQUENCY"
  ,"MODE": "MODE"
  ,"MODE.SNGL": "MODE.SNGL"
  ,"NOW": "NOW"
  ,"TIME": "TIME"
  ,"HOUR": "HOUR"
  ,"MINUTE": "MINUTE"
  ,"SECOND": "SECOND"
  ,"DATEDIF": "DATEDIF"
  ,"DATEVALUE": "DATEVALUE"
  ,"TIMEVALUE": "TIMEVALUE"
  ,"DAYS": "DAYS"
  ,"DAYS360": "DAYS360"
  ,"EDATE": "EDATE"
  ,"EOMONTH": "EOMONTH"
  ,"WEEKDAY": "WEEKDAY"
  ,"WEEKNUM": "WEEKNUM"
  ,"ISOWEEKNUM": "ISOWEEKNUM"
  ,"NETWORKDAYS": "NETWORKDAYS"
  ,"WORKDAY": "WORKDAY"
  ,"YEARFRAC": "YEARFRAC"
  ,"SEARCH": "SEARCH"
  ,"REPLACE": "REPLACE"
  ,"REPT": "REPT"
  ,"EXACT": "EXACT"
  ,"CHAR": "CHAR"
  ,"CODE": "CODE"
  ,"CLEAN": "CLEAN"
  ,"PROPER": "PROPER"
  ,"DOLLAR": "DOLLAR"
  ,"FIXED": "FIXED"
  ,"TEXTJOIN": "TEXTJOIN"
  ,"NUMBERVALUE": "NUMBERVALUE"
  ,"TEXTBEFORE": "TEXTBEFORE"
  ,"TEXTAFTER": "TEXTAFTER"
  ,"TYPE": "TYPE"
  ,"N": "N"
  ,"NA": "NA"
  ,"ERROR.TYPE": "ERROR.TYPE"
  ,"ISEVEN": "ISEVEN"
  ,"ISODD": "ISODD"
  ,"ISLOGICAL": "ISLOGICAL"
  ,"ISNA": "ISNA"
  ,"ISNONTEXT": "ISNONTEXT"
  ,"ISERR": "ISERR"
  ,"ISREF": "ISREF"
  ,"ISFORMULA": "ISFORMULA"
  ,"SHEET": "SHEET"
  ,"SHEETS": "SHEETS"
  ,"SIN": "SIN"
  ,"COS": "COS"
  ,"TAN": "TAN"
  ,"ASIN": "ASIN"
  ,"ACOS": "ACOS"
  ,"ATAN": "ATAN"
  ,"ATAN2": "ATAN2"
  ,"SINH": "SINH"
  ,"COSH": "COSH"
  ,"TANH": "TANH"
  ,"ACOT": "ACOT"
  ,"COT": "COT"
  ,"CSC": "CSC"
  ,"SEC": "SEC"
  ,"SQRTPI": "SQRTPI"
  ,"PERMUT": "PERMUT"
  ,"COMBINA": "COMBINA"
  ,"MULTINOMIAL": "MULTINOMIAL"
  ,"SERIESSUM": "SERIESSUM"
  ,"BASE": "BASE"
  ,"DECIMAL": "DECIMAL"
  ,"ROMAN": "ROMAN"
  ,"ARABIC": "ARABIC"
  ,"AGGREGATE": "AGGREGATE"
  ,"CEILING.PRECISE": "CEILING.PRECISE"
  ,"FLOOR.PRECISE": "FLOOR.PRECISE"
  ,"SUMX2MY2": "SUMX2MY2"
  ,"SUMX2PY2": "SUMX2PY2"
  ,"SUMXMY2": "SUMXMY2"
  ,"FACTDOUBLE": "FACTDOUBLE"
  ,"CORREL": "CORREL"
  ,"COVARIANCE.P": "COVARIANCE.P"
  ,"COVARIANCE.S": "COVARIANCE.S"
  ,"SLOPE": "SLOPE"
  ,"INTERCEPT": "INTERCEPT"
  ,"RSQ": "RSQ"
  ,"FORECAST": "FORECAST"
  ,"FORECAST.LINEAR": "FORECAST.LINEAR"
  ,"FISHER": "FISHER"
  ,"FISHERINV": "FISHERINV"
  ,"GEOMEAN": "GEOMEAN"
  ,"HARMEAN": "HARMEAN"
  ,"TRIMMEAN": "TRIMMEAN"
  ,"DEVSQ": "DEVSQ"
  ,"AVEDEV": "AVEDEV"
  ,"SKEW": "SKEW"
  ,"KURT": "KURT"
  ,"STANDARDIZE": "STANDARDIZE"
  ,"CONFIDENCE.NORM": "CONFIDENCE.NORM"
  ,"NORM.S.DIST": "NORM.S.DIST"
  ,"NORM.DIST": "NORM.DIST"
  ,"NORM.S.INV": "NORM.S.INV"
  ,"NORM.INV": "NORM.INV"
  ,"POISSON.DIST": "POISSON.DIST"
  ,"BINOM.DIST": "BINOM.DIST"
  ,"WEIBULL.DIST": "WEIBULL.DIST"
  ,"EXPON.DIST": "EXPON.DIST"
  ,"LOGNORM.DIST": "LOGNORM.DIST"
  ,"SORT": "SORT"
  ,"UNIQUE": "UNIQUE"
  ,"FILTER": "FILTER"
  ,"SORTBY": "SORTBY"
  ,"FORMULATEXT": "FORMULATEXT"
  ,"AREAS": "AREAS"
  ,"T": "T"
  ,"UNICHAR": "UNICHAR"
  ,"UNICODE": "UNICODE"
  ,"TEXTSPLIT": "TEXTSPLIT"
  ,"VALUETOTEXT": "VALUETOTEXT"
  ,"ARRAYTOTEXT": "ARRAYTOTEXT"
  ,"ENCODEURL": "ENCODEURL"
  ,"WORKDAY.INTL": "WORKDAY.INTL"
  ,"NETWORKDAYS.INTL": "NETWORKDAYS.INTL"
  ,"FV": "FV"
  ,"PV": "PV"
  ,"PMT": "PMT"
  ,"NPER": "NPER"
  ,"RATE": "RATE"
  ,"NPV": "NPV"
  ,"IRR": "IRR"
  ,"MIRR": "MIRR"
  ,"SLN": "SLN"
  ,"SYD": "SYD"
  ,"DB": "DB"
  ,"DDB": "DDB"
  ,"PPMT": "PPMT"
  ,"IPMT": "IPMT"
  ,"CUMIPMT": "CUMIPMT"
  ,"CUMPRINC": "CUMPRINC"
  ,"EFFECT": "EFFECT"
  ,"NOMINAL": "NOMINAL"
  ,"DOLLARDE": "DOLLARDE"
  ,"DOLLARFR": "DOLLARFR"
  ,"CELL": "CELL"
  ,"INFO": "INFO"
}
